import { del, get, post, put } from "aws-amplify/api";
import { API_NAME_VELAVU, normalizePromiseError, operationToJSON } from "../util/amplify-utils";
export default class VelavuAPIUsers {
    //This method returns all of an organization's users.
    getAllUsers() {
        return normalizePromiseError(operationToJSON(get({
            apiName: API_NAME_VELAVU,
            path: "/users",
        })));
    }
    //This request creates a new user profile and sends a profile activation email to their email.
    registerNewUser(params) {
        return normalizePromiseError(operationToJSON(post({
            apiName: API_NAME_VELAVU,
            path: "/users",
            options: {
                body: params,
            },
        })));
    }
    //This request retrieves a single user's data.
    getSpecificUser(userEmail) {
        return normalizePromiseError(operationToJSON(get({
            apiName: API_NAME_VELAVU,
            path: `/users/${userEmail}`,
        })));
    }
    // This method can be used to save persistent user settings that are relevant to the application.
    // Settings must be a dictionary of key-value pairs.
    updateSpecificUserSettings(userEmail, params) {
        return normalizePromiseError(operationToJSON(put({
            apiName: API_NAME_VELAVU,
            path: `/users/${userEmail}`,
            options: {
                body: params,
            },
        })));
    }
    //This method deletes a user profile.
    deleteUser(userEmail) {
        return normalizePromiseError(del({
            apiName: API_NAME_VELAVU,
            path: `/users/${userEmail}`,
        }).response);
    }
    //This method uploads a profile picture for a user.
    uploadProfilePicture(userEmail, imageBase64) {
        return normalizePromiseError(operationToJSON(put({
            apiName: API_NAME_VELAVU,
            path: `/users/${userEmail}/profile_img`,
            options: {
                body: {
                    image: imageBase64,
                },
            },
        })));
    }
    //This method deletes a person's profile image.
    deleteProfilePicture(userEmail) {
        return normalizePromiseError(del({
            apiName: API_NAME_VELAVU,
            path: `/users/${userEmail}/profile_img`,
        }).response);
    }
}
//# sourceMappingURL=velavu-api-users.js.map